import {COLLECTION_USER} from '../users/constants';
import {COLLECTION_TRADE_TAGS} from './constants';

export function getTradeTagsCollectionPath(uid: string): string {
  return `${COLLECTION_USER}/${uid}/${COLLECTION_TRADE_TAGS}`;
}
